import { Monitor, Moon, Sun } from "lucide-react";
import { type Theme, useTheme } from "@/hooks/useTheme";
import { fr } from "@/i18n/fr";

const OPTIONS: { value: Theme; label: string; Icon: typeof Sun }[] = [
	{ value: "light", label: fr.theme.light, Icon: Sun },
	{ value: "system", label: fr.theme.system, Icon: Monitor },
	{ value: "dark", label: fr.theme.dark, Icon: Moon },
];

/** Light · system · dark, as a small segmented control. */
export function ThemeToggle({ onInk }: { onInk?: boolean }) {
	const [theme, setTheme] = useTheme();
	return (
		<fieldset
			aria-label={fr.theme.label}
			className={`m-0 inline-flex gap-0.5 rounded-pill border p-[3px] ${onInk ? "border-on-ink/20 bg-on-ink/10" : "border-line bg-bg-sunken"}`}
		>
			{OPTIONS.map(({ value, label, Icon }) => (
				<button
					key={value}
					type="button"
					title={label}
					aria-label={label}
					aria-pressed={theme === value}
					onClick={() => setTheme(value)}
					className={`grid h-7 w-7 place-items-center md:w-8 rounded-pill transition ${onInk ? "text-on-ink/60 aria-pressed:bg-bg aria-pressed:text-fg" : "text-fg-muted aria-pressed:bg-bg-elev aria-pressed:text-fg aria-pressed:shadow-sm"}`}
				>
					<Icon className="size-4" aria-hidden="true" />
				</button>
			))}
		</fieldset>
	);
}
